import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash'
import compareVersions from 'compare-versions'
import { Col, Row } from 'react-bootstrap'
import ReleaseNote from './ReleaseNote'
import ReleaseTag from './ReleseTag'
import snuggLogo from '../../src/img/sp-logo.png'
import dimensions from 'util/dimensions'
import * as Sentry from '@sentry/react'

let fetchingNow = false
let requestedTagIntervalId

class ReleaseNotesContainer extends React.Component {
  constructor() {
    super()

    this.noteRefs = []

    this.state = {
      notes: [],
      areAllNotesFetched: false,
      isRequestedTagFetchedNow: false,
      activeNoteIndex: 0,
      expandVersionNavigation: dimensions.screenSize === 'lg' ? 1 : 0,
      isAuthorized: false,
    }
  }

  getLastFetchedTag = () => {
    const { notes } = this.state
    return notes.length > 0 ? notes[notes.length - 1].tag_name : null
  }

  getRequestedTagIndex = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const requestedTag = urlParams.get('tag')
    return _.findIndex(this.state.notes, ['tag_name', requestedTag])
  }

  fetchNotes = async (beforeTag) => {
    const urlParams = new URLSearchParams(window.location.search)
    const requestedTag = urlParams.get('tag')

    try {
      fetchingNow = true
      const response = await fetch(
        `/api/release-notes/public${beforeTag ? `?beforeTag=${beforeTag}` : ''}`,
      )
      const fetchedObj = await response.json()

      if (
        _.size(fetchedObj.notes) === 1 &&
        fetchedObj.notes[0].tag_name === beforeTag
      ) {
        this.setState({ areAllNotesFetched: true })
        return
      }

      const isRequestedTagFetchedNow =
        _.findIndex(fetchedObj.notes, ['tag_name', requestedTag]) >= 0
      const allNotes = _.uniqBy(
        [...this.state.notes, ...fetchedObj.notes],
        'id',
      )
      let updatedState = {
        notes: allNotes,
        isRequestedTagFetchedNow,
        isAuthorized: fetchedObj.isAuthorized,
      }
      if (!beforeTag) {
        updatedState.lastViewedTag = fetchedObj.lastViewedTag
      }
      this.setState(updatedState, () => {
        const requestedTagIndex = _.findIndex(allNotes, [
          'tag_name',
          requestedTag,
        ])
        if (requestedTagIndex === -1) {
          this.fetchNotes(this.getLastFetchedTag())
        } else {
          fetchingNow = false
        }
      })
    } catch (err) {
      console.error(err)
      Sentry.captureException(err)
    }
  }

  onScroll = async () => {
    const { areAllNotesFetched } = this.state

    const requestedTagIndex = this.getRequestedTagIndex()
    if (
      requestedTagIndex >= 0 &&
      this.noteRefs[requestedTagIndex].offsetTop <
        document.documentElement.scrollTop &&
      requestedTagIntervalId
    ) {
      // Disable autoscroll to requested tag, if user scrolls down
      clearInterval(requestedTagIntervalId)
    }

    const maxScrollTop =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight
    let activeNoteIndex = 0
    for (let i = 0; i < this.noteRefs.length; i++) {
      if (
        this.noteRefs[i].offsetTop + this.noteRefs[i].clientHeight >=
        document.documentElement.scrollTop
      ) {
        activeNoteIndex = i
        this.setState({ activeNoteIndex: i })
        break
      }
    }
    if (
      document.documentElement.scrollTop +
        (this.noteRefs[activeNoteIndex]
          ? this.noteRefs[activeNoteIndex].clientHeight
          : 0) >
        maxScrollTop &&
      !areAllNotesFetched &&
      !fetchingNow
    ) {
      fetchingNow = true
      await this.fetchNotes(this.getLastFetchedTag())
    }
  }

  scrollToRef(ref) {
    window.scrollTo(0, ref.offsetTop + 1)
  }

  async componentDidMount(): void {
    window.addEventListener('scroll', this.onScroll)
    await this.fetchNotes()
  }

  componentDidUpdate(prevProps, prevState): void {
    // Scroll to requested tag content when it is just loaded
    if (
      !prevState.isRequestedTagFetchedNow &&
      this.state.isRequestedTagFetchedNow
    ) {
      const requestedTagIndex = this.getRequestedTagIndex()
      let prevContainerHeight = null
      // Use set interval to handle content height change on images are loaded
      requestedTagIntervalId = setInterval(() => {
        if (prevContainerHeight !== document.body.scrollHeight) {
          prevContainerHeight = document.body.scrollHeight
          window.scrollTo(0, this.noteRefs[requestedTagIndex].offsetTop + 1)
        }
      }, 500)
      setTimeout(() => {
        if (requestedTagIntervalId) {
          clearInterval(requestedTagIntervalId)
        }
      }, 10000)
    }
  }

  componentWillUnmount(): void {
    window.removeEventListener('scroll', this.onScroll)
  }

  onMenuClick = (e) => {
    e.preventDefault()
    this.setState({
      expandVersionNavigation: !this.state.expandVersionNavigation,
    })
  }

  onTagClick = (e, ref, tag) => {
    e.preventDefault()
    this.scrollToRef(ref)
    window.history.pushState('', '', `?tag=${tag}`)
  }

  render() {
    const {
      notes,
      activeNoteIndex,
      lastViewedTag,
      expandVersionNavigation,
      isAuthorized,
    } = this.state
    const menuClassNames = expandVersionNavigation
      ? 'nav_icon open'
      : 'nav_icon'
    const versionNavigationclasses = expandVersionNavigation
      ? 'sidebar'
      : 'hide sidebar'
    return (
      <div>
        <div className="main-container">
          <header>
            <div className="container">
              <Row>
                <Col xs={12}>
                  <a href="https://snuggpro.com/">
                    <img
                      src={snuggLogo}
                      alt=""
                      width="166"
                      style={{ marginTop: 5 }}
                    />
                  </a>
                  <div className={menuClassNames} onClick={this.onMenuClick}>
                    {' '}
                    {/* ADD .OPEN CLASS FOR ANIMATING ON CLICK */}
                    <span />
                    <span />
                    <span />
                  </div>
                </Col>
              </Row>
            </div>
          </header>

          <section className="sub_header">
            <div className="container">
              <div className="row">
                <div className="col-md-9">
                  <h1>What's New</h1>
                  <p>
                    If you’re curious about what’s new and what's changed, this
                    change log is the place.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="container">
              <Row>
                <Col xs={12} lg={11}>
                  <div className="version_timeline">
                    {notes.map((n, i) => (
                      <div
                        key={n.id}
                        ref={(elem) => {
                          this.noteRefs[i] = elem
                        }}>
                        <ReleaseNote
                          {...n}
                          isLatest={i === 0}
                          isUnread={
                            isAuthorized &&
                            (lastViewedTag === null ||
                              compareVersions(n.tag_name, lastViewedTag) > 0)
                          }
                          onTagClick={this.onTagClick}
                          noteRef={this.noteRefs[i]}
                        />
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
            </div>
          </section>
        </div>
        <div className={versionNavigationclasses}>
          <h5>
            Version Navigation
            <div className={menuClassNames} onClick={this.onMenuClick}>
              {' '}
              {/* ADD .OPEN CLASS FOR ANIMATING ON CLICK */}
              <span />
              <span />
              <span />
            </div>
          </h5>

          <ul>
            {notes.map((n, i) => (
              <ReleaseTag
                onClick={(e) =>
                  this.onTagClick(e, this.noteRefs[i], n.tag_name)
                }
                key={n.id}
                {...n}
                isLatest={i === 0}
                isActive={i === activeNoteIndex}
                isUnread={
                  isAuthorized &&
                  (lastViewedTag === null ||
                    compareVersions(n.tag_name, lastViewedTag) > 0)
                }
              />
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

window.appInit = function (elementId) {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: _.get(SENTRY_RELEASE, 'id', SENTRY_RELEASE),
    environment: SERVER_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    attachStacktrace: true,
  })
  ReactDOM.render(<ReleaseNotesContainer />, document.getElementById(elementId))
}
